import type { CounselorRegistration } from '@leangap/types'
import { post } from './api'
import { ContactResponseSchema } from '@leangap/types'
import { PATHS } from './endpoints'

type CounselorResponse = { success: boolean; message: string }

export async function submitCounselorRegistration(data: CounselorRegistration) {
	return post<CounselorResponse>(PATHS.counselor, data, ContactResponseSchema)
}
